export function wrapCarouselIndex(index: number, total: number) {
  if (total <= 0) {
    return 0;
  }

  return ((Math.round(index) % total) + total) % total;
}

export function getNearestWrappedProgress(targetIndex: number, currentProgress: number, total: number) {
  if (total <= 0) {
    return 0;
  }

  const wrappedTarget = wrapCarouselIndex(targetIndex, total);
  const currentTurn = Math.round((currentProgress - wrappedTarget) / total);

  let best = wrappedTarget + currentTurn * total;
  let bestDistance = Math.abs(best - currentProgress);

  for (const candidate of [best - total, best + total]) {
    const distance = Math.abs(candidate - currentProgress);
    if (distance < bestDistance) {
      best = candidate;
      bestDistance = distance;
    }
  }

  return best;
}

export function getCircularDelta(index: number, rotationProgress: number, total: number) {
  if (total <= 0) {
    return 0;
  }

  const base = wrapCarouselIndex(rotationProgress, total);
  let delta = index - base;
  const half = total / 2;

  if (delta > half) {
    delta -= total;
  } else if (delta < -half) {
    delta += total;
  }

  const fractionalOffset = rotationProgress - Math.round(rotationProgress);

  return delta - fractionalOffset;
}
